import {createSlice} from '@reduxjs/toolkit';
import { MEET_DETAILS } from '../../../constants/reducer_names';

const initialState={
    meetingDetails: {
        alternate_host: [],
        calender_type: '',
        description: '',
        dial_in_countries: [],
        duration_minutes: 0,
        end_timestamp: 0,
        invite_url: '',
        is_alternate_host: false,
        is_attended: 0,
        is_cancelled: 0,
        is_host_myvideo: false,
        is_participant_invite_guest: false,
        is_participant_join_bef_host: false,
        is_participant_mute_entry: false,
        is_participant_video: false,
        is_participant_waiting_room: false,
        is_record_meeting: false,
        is_use_personal_meeting_id: false,
        joining_option_type: '',
        meeting_id: '',
        participants: [],
        password: '',
        personal_meeting_id: '',
        rrule: '',
        save_template: false,
        sip_id: '',
        start_timestamp: 0,
        status: '',
        timezone: '',
        title: '',
        uuid: '',
        time: '',
        is_custom_password: '',
        recurrence: '',
        isScreenshareStarted: false,
        isWhiteboardStarted: false
      },
      sockmeetDetails: {
        isHostjoined: false,
        isParticipantjoinbefhost: false,
        restrictScreenShare:false,
        chatEnabled: false,
        chatSetting: "",
        meetStartTime:0,
        lockMeeting: false,
        renameingParticipant: false,
        isWhiteboardStarted: false,
        isScreenshareStarted: false,
        meetingId: '',
        meetingName: '',
        screenShare: false,
        waitingRoom: false,
        devicesInfo: {},
        conversations: [],
        generalSetting: {
          isChat: false,
          isScreenShare: false,
          renameThemselves: false,
          lockMeeting: false,
          is_participant_unmute_themselves: false,
          isWaitingroom: false,
          is_participant_mute_entry: false,
          shareOptions: {
            howManyPart: "",
            startShare: "",
            whoShare: ""
          }
        },
        isHostAudioMute: false,
        hostDetails: {
          isRecordingAllowed: false,
          isHost: false,
          mute: false,
          name: '',
          pined: false,
          removeFromMeeting: false,
          video: false,
          conId: '',
          deviceid: '',
          isGuest: false,
          ext: 0,
          hand: false,
          isAlternateHost: false,
          moveToWaitingRoom: false,
          profileImg: '',
          roleType: 0,
          sipId: '',
          status: '',
          waiting_retrycount: 0,
          recordingStatus:"stop",
          isActive: false,
          // audioPitch:1,
          isMirror: true,
          isScreenshare:false,
          closedCaption: false
        }
      }, workcontact: [],
      teamContacs:[],
      favContacts:[],
      isTeamContactLoading:false,
      activeParticipantList: [],
      activeParticipantListWH: [],
      waitingRoomList: [],
      recordingEnabledList: [],
      ccUserList: [],
      muteStatus:false,
      currdeviceid: "",
      currdeviceinfo: {
        isRecordingAllowed: false,
        isHost: false,
        mute: false,
        name: '',
        pined: false,
        removeFromMeeting: false,
        video: false,
        conId: '',
        deviceid: '',
        isGuest: false,
        ext: 0,
        hand: false,
        isAlternateHost: false,
        moveToWaitingRoom: false,
        profileImg: '',
        roleType: 0,
        sipId: '',
        status: '',
        waiting_retrycount: 0,
        recordingStatus:"stop",
        isActive: false,
        // audioPitch:1,
        isMirror: true,
        isScreenshare:false,
        closedCaption: false
      },
      isError: { message: '' },
      isSuccess: { message: '' },
      isLoading: false,
      thankYou: false,
      isFailure:false,
      connstatus: "",
      arrowKey: false,
      draggableScreen: false,
      audioStream: "",
      videoStream: "",
      pin: [],
      activeSpeaker: {},
      gridViewSize: 7,
      joinUser: false,
      openWR: false,
      retryCount: 0,
      unmuteReq: false,
      recordAllowed: false,
      showRecording: false,
      closeCaptionData: [],
      // captionStatus: "",
      // captionBoolean:false,
      // ccSpeaker: [],
      // speakerName:'',
      recordPopup:false,
      muteToggle:false,
      videoToggle:true,
      videoToggleDelay:false,
      AskToJoinButtonStatus:false,
      unmuteReqParticipant: false,
      videoUnHideReq:false,
      hostReqVideoAudioKey:"",
      unmuteParticipant:{
        isRecordingAllowed: false,
        isHost: false,
        mute: false,
        name: '',
        pined: false,
        removeFromMeeting: false,
        video: false,
        conId: '',
        deviceid: '',
        isGuest: false,
        ext: 0,
        hand: false,
        isAlternateHost: false,
        moveToWaitingRoom: false,
        profileImg: '',
        roleType: 0,
        sipId: '',
        status: '',
        waiting_retrycount: 0,
        recordingStatus:"stop",
        isActive: false,
        // audioPitch:1,
        isMirror: true,
        isScreenshare:false,
        closedCaption: false
      },
      sendunmuteReq:false,
      instatus: "",
      ssKey: false,
      ssCancel: false,
      ssPermit: false,
      ssOpen: false,
      meetingTitleStatus: false,
      meetStatus:"",
      ssDetails:{},
      currentPage: 0,
      startPage: 0,
      autoDraggable: false,
      currentScreenParticipant:[],
      browserVersion:'107',
      browserType:'Chrome',
      iceState: false,
      isSocketInit:false,
      isTransoportClose:false,
      isInstantMeetingLoader:false,
          clientDomain:{
            urapi: "https://qaurapi.worktual.co.uk",
            videosgw: "videosgw.worktual.co.uk",
            meetsocket: "https://urmeet-io.worktual.co.uk",
            videoturnv4: "turn:audioturnv4.worktual.co.uk:3478",
            videoturnv6: "turn:audioturnv6.worktual.co.uk:3478"
          },
          hideSelf:false,
          hideNonVideo:false,
          fullScreen:false,
          agentvideo:false
          
};


const meetSlice=createSlice({
    name:MEET_DETAILS,
    initialState,
    reducers:{
updateMeetDetails:(state,{payload})=>{
    console.log(state,payload)
state.meetingDetails=payload.meetingDetails
},
updateSocketMeetDetails:(state,{payload})=>{
    state.sockmeetDetails=payload.sockmeetDetails
    state.activeParticipantList=payload.activeParticipantList
    state.activeParticipantListWH=payload.activeParticipantListWH
    state.waitingRoomList=payload.waitingRoomList
    state.recordingEnabledList=payload.recordingEnabledList
    state.currdeviceid=payload.currdeviceid
    state.currdeviceinfo=payload.currdeviceinfo
    state.ccUserList=payload.ccUserList
},
updateSocketError:(state,{payload})=>{
    state.isError=payload.isError
    state.isSuccess=payload.isSuccess
},
updateSocketLoading:(state,{payload})=>{
state.isLoading=payload.isLoading
},
updateAudioStream:(state,{payload})=>{
    state.audioStream=payload.audioStream
},
updateVideoStream:(state,{payload})=>{
    state.videoStream=payload.videoStream
},
updateSocketThank:(state,{payload})=>{
    state.thankYou=payload.thankYou
    state.connstatus=payload.connstatus
    state.isFailure=payload.isFailure
},
updateActivePart:(state,{payload})=>{
    state.activeParticipantList= payload.activeParticipantList
},
socketJoin:(state,{payload})=>{
    state.joinUser=payload.joinUser
},
updateInstantLoading:(state,{payload})=>{
    state.isInstantMeetingLoader=payload.isInstantMeetingLoader
},
transportLoadingState:(state,{payload})=>{
    state.isTransoportClose=payload.isTransoportClose
},
socketInitStatus:(state,{payload})=>{
    state.isSocketInit=payload.isSocketInit
},
iceConnectionState:(state,{payload})=>{
state.iceState=payload.iceState
},
updateBrowserType:(state,{payload})=>{
state.browserType=payload.browserType
state.browserVersion=payload.browserVersion
},
updateCurrentPart:(state,{payload})=>{
    state.currentScreenParticipant=payload.currentScreenParticipant;
},
updateMeetStatus:(state,{payload})=>{
    state.meetStatus=payload.meetStatus;
},
updateConnectState:(state,{payload})=>{
    state.connstatus=payload.connstatus
},
waitingRoom:(state,{payload})=>{
    state.openWR=payload.openWR;
},
toggleVdoDelay:(state,{payload})=>{
    state.videoToggleDelay=payload.videoToggleDelay
},
toggleAudio:(state,{payload})=>{
    state.muteToggle=payload.muteToggle
},
updateMuteStatus:(state,{payload})=>{
    state.muteStatus=payload.muteStatus
},
updateInstatus:(state,{payload})=>{
    state.instatus=payload.instatus
},
updateFs:(state,{payload})=>{
    console.log(payload,"fullscreen payload==");
    
    state.fullScreen=payload.fullScreen
},
updateVideoAgent:(state,{payload})=>{
    console.log(payload,"fullscreen payload==");
    
    state.agentvideo=payload.agentvideo
},
    }


})
export const meetActions = meetSlice.actions;
export default meetSlice.reducer;